import { toOrderOperationalModel, type OrderOperationalModel } from '@hopdrive/feature-order-index';
import { useProductEntry } from '@hopdrive/feature-portal-products';

/** The working rooftop's Moves operational model as the order index reads it: the customer's
 * default from the Valet products it uses (or, using none, its lapsed contracts), with `mixed` falling to the package default. A rendered
 * order still reads its own per-order fact; this is the rooftop-grain fallback. */
export function useMovesOrderOperationalModel(): OrderOperationalModel {
  return toOrderOperationalModel(useProductEntry('moves')?.operationalModel?.default);
}
